export var Language;
(function (Language) {
    Language["EN"] = "EN";
    Language["TH"] = "TH";
    Language["KO"] = "KO";
    Language["VI"] = "VI";
    Language["ID"] = "ID";
    Language["RO"] = "RO";
    Language["ES"] = "ES";
    Language["IT"] = "IT";
    Language["ZH_CN"] = "ZH-CN";
})(Language || (Language = {}));
